module.exports = __webpack_public_path__ + "img/16m003-15.a88786a2.png";